export const getSectionReturnPath = (search: string, state?: unknown, fallback = '/qrcode') => {
  const savedPath =
    state && typeof state === 'object' && 'fromHomePage' in state ? state.fromHomePage : undefined;
  const requestedPath = new URLSearchParams(search).get('next') || savedPath;
  return typeof requestedPath === 'string' &&
    requestedPath.startsWith('/') &&
    !requestedPath.startsWith('//') &&
    !requestedPath.startsWith('/section')
    ? requestedPath
    : fallback;
};
